<table class="dynamicLayoutHTML">
    <tbody *ngIf="_tile.IsHorizontal && _tile.ShowLabelAboveValue">
        <!-- HORIZONTAL show label ABOVE value-->
        <tr *ngIf="_tile.ShowHeaders">
            <th *ngFor="let c of _tile.Columns">{{c.Label}}</th>
        </tr>
        <tr>
            <td *ngFor="let c of _tile.Columns">{{_values[c.ColumnId]}}</td>
        </tr>
    </tbody>
    <tbody *ngIf="_tile.IsHorizontal && !_tile.ShowLabelAboveValue && _tile.ShowHeaders">
        <!--HORIZONTAL show label BESIDE value WITH headers-->
        <tr>
            <th *ngFor="let c of _tile.Columns">{{c.Label}}</th>
        </tr>
        <tr>
            <td *ngFor="let c of _tile.Columns">{{_values[c.ColumnId]}}</td>
        </tr>
        <tr><td class="spacer"></td></tr>
    </tbody>
    <tbody *ngIf="_tile.IsHorizontal && !_tile.ShowLabelAboveValue && !_tile.ShowHeaders">
        <!--HORIZONTAL show label BESIDE value WITHOUT headers-->
        <tr>
            <td *ngFor="let c of _tile.Columns">{{_values[c.ColumnId]}}</td>
        </tr>
    </tbody>

    <tbody *ngIf="!_tile.IsHorizontal && _tile.ShowLabelAboveValue">
        <div *ngFor="let c of _tile.Columns">
            <!--VERTICAL show label ABOVE value-->
            <tr *ngIf="_tile.ShowHeaders">
                <th>{{c.Label}}</th>
            </tr>
            <tr>
                <td>{{_values[c.ColumnId]}}</td>
            </tr>
            <tr><td class="spacer"></td></tr>
        </div>
    </tbody>

    <tbody *ngIf="!_tile.IsHorizontal && !_tile.ShowLabelAboveValue">
        <!--VERTICAL show label BESIDE value-->
        <tr *ngFor="let c of _tile.Columns">
            <th *ngIf="_tile.ShowHeaders">{{c.Label}}</th>
            <td>{{_values[c.ColumnId]}}</td>
        </tr>
    </tbody>
</table>
